module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_cuadrada_fondo_8.d3e7f2e7.png";